<template>
<v-card tile flat>
    <div v-for="(item, index) in items" :key="index" class="detail mx-2 my-1">
        <div v-if="item.sortable" :class="{'sort-item': item.sortable, 'header-title': true}">
            <v-row no-gutters>
                <v-col cols="8" class="regular">
                    <div class="text-capitalize" :class="[item.sort_dir !== null ? 'sort-item' : '' ]">{{ item.text }}</div>
                </v-col>
                <v-col cols="2">
                    <v-icon :color="item.sort_dir == 'asc' ? 'primary' : 'grey darken-1'" small @click="changeOrder(item, index, 'asc')">arrow_upwards</v-icon>
                </v-col>
                <v-col cols="2">
                    <v-icon :color="item.sort_dir == 'desc' ? 'primary' : 'grey darken-1'" small @click="changeOrder(item, index, 'desc')">arrow_downwards</v-icon>
                </v-col>
            </v-row>
        </div>
    </div>
</v-card>
</template>

<script>
export default {
    name: "SortField",
    props: {
        items: Array
    },

    computed: {},
    methods: {
        changeOrder(value, item_index, order) {
            if(value.sortable === true) {
                this.items.forEach(function (element, index) {
                    if(item_index !== index) {
                        element.sort_dir = null;
                    }
                });
                this.items[item_index].sort_dir = order;
                this.$emit("clickSort", value);
            }
        }
    }
};
</script>

<style scoped>
.sort-item {
    color: #795548;
}
</style>
